import { render, staticRenderFns } from "./right1.vue?vue&type=template&id=961c4ec8&scoped=true&"
import script from "./right1.vue?vue&type=script&lang=js&"
export * from "./right1.vue?vue&type=script&lang=js&"
import style0 from "./right1.vue?vue&type=style&index=0&id=961c4ec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c4ec8",
  null
  
)

export default component.exports